export default {
	message: {
		cart: 'カート',
		home: 'ホームページ',
		discountText: 'すべての商品は40％オフ',
		headingTitle: '新品',
		addToCart: 'カートに入れる',
		price: '価格',
		rate: '評価',
		TotalPrice: '総合価格',
		//
		goodNum: '数量',
		buyNow: '今すぐ買います',
		addCart: 'カートに追加',
		productDetailTitle: '商品の詳細',
		productRecommendationsTitle: '商品のおすすめ',
		categoryTitle: '商品の分類',
		hotgoodstitle: 'ヒット商品',
		smallDetails: '本商品の人気販売中',
		orderSale: '販売済み',
		msgLanguage: '参加に成功しました',

		//
		buyItNow: '今 买っちゃう',
		shipping: 'シッピング',
		pay: '支払い',
		back: '返金',
		support: 'サポート',
		shippingDesc: '厳選されたセールス',
		checkOut: '決済',
		viewCart: 'カートチェック',
		agreePrivacy: 'プライバシー規約に同意',
		remove: 'デリート',
		total: '合計',
		language: '言語',


    // 支付弹窗
    dialogPayTitle: '受取先を記入します', //填写收货地址
    dialogPayUserX: '受取人の苗字', //收货人姓
    dialogPayUserM: '受取人の名', //收货人名
    dialogPayPhone: '電話番号', //电话号码
    dialogPayEmail: 'メールアドレス', //邮箱地址

    dialogPayBankCard:'銀行カード入金',// 银行卡收款
    dialogPayClientName:'顧客名', // 客户姓名 ---银行卡收款
    dialogPayFullAddress:'顧客住所', // 客户地址 ---银行卡收款
    dialogPayBankName:'銀行名', // 银行名称 ---银行卡收款
    dialogPayCardNumber:'銀行カード番号', // 银行卡号 ---银行卡收款
    dialogPayCardHolder:'カード所持者', // 持卡人 ---银行卡收款
    dialogPaySubmit:'コミット成功', // 提交成功 ---银行卡收款
    dialogPayProductName:'製品名', // 商品名称 ---银行卡收款
    dialogPayProductAmount:'商品の金額', // 商品金额 ---银行卡收款

    dialogPayPostalCode: '郵便番号', //邮政编码
    dialogPayAdminArea1: '都道府県', //省份/州
    dialogPayAdminArea2: '市区町村', //城市/城镇/村
    dialogPayAddressLine1: '街/番地', //街道/门牌号
    dialogPayAddressLine2: 'スイート/マンション番号', //套房/公寓号码
    dialogPayInput: '入力してください', // 请输入
    dialogPayFSelect: '先にお願いします', // 请先选择
    dialogPaySelect: '選択をお願いします', // 请选择
    dialogPayGo: "支払いへ", //前往支付
    dialogPayReset: "リセット", //一键重置
    dialogPayClose: "閉じる", //关闭
    dialogPayErrorTip1: "注文書の記入に誤りがありますので、ご確認ください。", //订单填写有误，请检查一下
    dialogPayErrorTip2: "Urlを空にすることはできません。リンクが正しいかどうか注意してください。", // Url不能为空，请注意链接是否正确
    dialogPayErrorTip3: "この項を空にしてはいけません",// 该项不能为空
    dialogPayErrorTip4: "正しいメールアドレスの入力をお願いします",// 请输入正确的邮箱地址
    dialogPayErrorTip5: "韓国郵便番号は5桁の数字で構成されています",// 韩国邮编由5位数字组成
    dialogPayErrorTip6: "日本の郵便番号は3桁までが数字です",// 日本邮编前三位为数字
    dialogPayErrorTip7: "日本郵便番号は下4桁が数字です",// 日本邮编后四位为数字
    dialogPayErrorTip8: "日本の郵便番号は7桁の数字で,上の3桁と下の4桁が数字です",// 日本邮编由7位数字组成,前三位和后四位为数字
    dialogPayErrorTip9: "国や地域へのアクセスに失敗しました",// 国家地区获取失败
    cartClear: "一括削除", //购物车 清空
    cartRemove: "削除",// 购物车 删除
    checkOut: '決済',//结账
    viewCart: 'カートチェック', //查看购物车
    categoryTitle: '商品の分類',//商品分类

    // 联系我们字段
    openingHours: '営業時間', // 营业时间
    openingHoursText:'毎日の午前10時から午後6時ま', //每周上午 10 点至下午 6 点
    contactEmail: 'Eメール', // 电子邮件
    contactPhone: '電話番号', // 电话号码
    companyName: '会社', // 公司
    companyAddress: '住所', // 地址
    principalName: '会社の主体者',// 公司主体人
    crNumber: '会社登録番号(CR)',// 公司注册号 (CR)
    brNumber: '会社商証番号(BR)',// 公司商证号 (BR)

    cartEmpty:"ない",//暂无
    
		aboutUsText: '我々について',
		aboutUsContent: `<div class="product__tab--content__step">
      <h2 class="product__tab--content__title">我々について</h2>
      <p>キンスイ貿易株式会社はブランドのＰＲ、開発と製造、セールスを統合する会社です。本社には優れるセールスチームと国内の各エリアで協力工場がございます。マーケットの開拓とアフターサービスなどについて健全な管理で仕組んでおります。通販サイトも製品の代理店も全国の各地で設立されています。同時に「信用が第一、お客様が神」の理念を基づき、お客様の利益を最優先にし、精いっぱいお客様に最高の製品とサービスを提供いたします。</p>
    </div>`,
		contactUsText: 'コンタクト',
		contactUsContent: `<div class="product__tab--content__step">
    <h2 class="product__tab--content__title">コンタクト</h2>      
    <p>営業時間：毎日の午前10時から午後6時まで</p>
    <p>Eメール：1571964822@qq.com</p>
    <p>電話番号：+86 13342815021</p>
    <p>会社：キンスイ貿易株式会社</p>
    <p>住所：香港チムサーチョイ科学博物館通り14番地新マンダプラザ9階A区917Ｂ室 FLAT/RM 917B BLK A 9/F NEW MANDARIN PLAZA NO.14 SCIENCE MUSEUM RD TST HONG KONG</p>
    </div>`,
		refundsText: '返品と交換',
		refundsContent: `<div class="product__tab--content__step">
      <h2 class="product__tab--content__title">返品、返金、交換</h2>
      <p>顧客は製品の受領後15日以内に返品を申請する権利を有します</p>
      <p>返品の対象となるには、商品は未使用であり、受け取ったときと同じ状態である必要があります。また、元のパッケージに入っている必要があります。</p>
      <p>返品を完了するには、領収書または購入証明書が必要です。</p>
      <p>ご購入いただいた商品をメーカーに返送しないでください。</p>
      <p>払い戻し（該当する場合）</p>
      <p>返品が受領され検査されたら、返品商品を受領したことを通知する電子メールを送信します。また、返金の承認または拒否についてもお知らせします。</p>
      <p>承認されると、返金が処理され、一定の日数以内にクレジット カードまたは元の支払い方法に自動的にクレジットが適用されます。</p>
      <p>払い戻しの遅延または欠落（該当する場合）</p>
      <p>払い戻しをまだ受け取っていない場合は、まず銀行口座をもう一度確認してください。</p>
      <p>その後、クレジット カード会社に問い合わせてください。返金が正式に行われるまでに時間がかかる場合があります。</p>
      <p>次に銀行にお問い合わせください。多くの場合、返金が行われるまでにある程度の処理時間がかかります。</p>
      <p>これらすべてを行ってもまだ払い戻しを受け取っていない場合は、当社までご連絡ください。</p>
      <p>セール品（該当する場合）</p>
      <p>返品できるのは通常価格の商品のみです。残念ながら、セール品は返金できません。</p>
      <p>交換（該当する場合）</p>
      <p>不良品、破損がある場合のみ交換させていただきます。同じ商品との交換が必要な場合は、メールでご連絡いただければ返品先住所をお知らせいたします。</p>
      <p>ギフト</p>
      <p>購入時に商品がギフトとしてマークされており、お客様に直接発送された場合は、返品の金額に応じたギフト クレジットを受け取ります。返品商品が到着次第、ギフト券を郵送させていただきます。</p>
      <p>購入時に商品がギフトとしてマークされていなかった場合、またはギフトの贈り主が後であなたに贈るために注文品を自分宛てに発送した場合、当社はギフトの贈り主に返金し、ギフトの贈り主がお客様の返品について知ることになります。</p>
      <p>運送</p>
      <p>製品を返品するには、まず詳細情報をメールでお送りください。</p>
      <p>代金返却方針：</p>
      <p>返金には関連する手数料を差し引く必要があります。</p>
      <p>返品先:韓国仁川西区石南洞650-41 1棟2階建て</p>
    </div>`,
		privacyText: 'プライバシー規約',
		privacyContent: `
      <div class="product__tab--content__step">
        <h2 class="product__tab--content__title">プライバシー規約</h2>
        <p>あなたの情報をどうするのですか？</p>
        <p>あなたが当店で何かを購入するとき、売買プロセスの一環として、私たちはあなたが私たちに提供するあなたの名前、住所、電子メールアドレスなどの個人情報を収集します。</p>
        <p>お客様が当社のストアを閲覧すると、当社はお客様のブラウザとオペレーティング システムについて知るのに役立つ情報を提供するために、お客様のコンピュータのインターネット プロトコル (IP) アドレスも自動的に受け取ります。</p>
        <p>電子メール マーケティング (該当する場合): お客様の許可を得て、ストア、新製品、その他の更新情報に関する電子メールを送信する場合があります。</p>
        <p>プライバシーセキュリティ</p>
        <p>当社は、通常の業務の一環として、個人を特定できる情報をいかなる個人または企業に対しても販売、取引、または賃貸することはありません。ただし、自分のアカウント情報を安全に保管し、他人にアカウント情報を開示しないものとします。</p>
        <p>購読を解除するにはどうすればよいですか?</p>
        <p>電子メール ニュースレターの下部にあるリンクを使用して購読を解除するか、Web サイトのユーザー アカウント ページで購読設定を変更できます。</p>
        <p>お問い合わせ</p>
        <p>このプライバシーポリシーまたは当社によるお客様の情報の処理に関してご質問、ご意見、ご要望がございましたら、お気軽にお問い合わせください。</p>
      </div>
    `,
		shippingText: 'シッピング',
		shippingContent: `<div class="product__tab--content__step ">
      <h2 class="product__tab--content__title">シッピング</h2>
      <p>合計配達時間 = 処理時間 + 発送時間</p>
      <p>お客様に送料が請求されるのは最大 1 回だけです (これには返品も含まれます)。製品の返品に対して消費者に請求される補充はありません。</p>
      <p>処理時間: 出荷前に製品の品質を保証するために、出荷前に品質管理チェックとテストを実施します。通常2～7営業日。ただし、商品の在庫状況によっても変動する場合がございます。在庫状況に問題が発生している人気商品の場合、処理に 2 ～ 9 営業日かかる場合があります。</p>
      <p>私たちは海外サイト、国際物流です</p>
    </div>`,
		termsText: '条項と規約',
		termsContent: `<div class="product__tab--content__step">
    <h2 class="product__tab--content__title">条項と規約</h2>
    <strong class="h5">概要</strong>
    <p>当社は、ここに記載されているすべての利用規約、ポリシー、および通知に同意することを条件として、このウェブ サイトで利用可能なすべての情報、ツール、およびサービスを含むこの ウェブ サイトをユーザーであるお客様に提供します。</p>
    <p>当社のウェブ サイトにアクセスする、または当社から何かを購入することにより、お客様は当社の「サービス」に参加し、これらの追加の利用規約およびこのポリシーは引用されているか、ハイパーリンク経由で入手できます。 これらの利用規約は、ブラウザ、サプライヤー、顧客、販売者、および/またはコンテンツの寄稿者を含むがこれらに限定されない、サイトのすべてのユーザーに適用します。</p>
    <p>当社ウェブサイトにアクセスまたは使用する前に、これらの利用規約をご熟知ください。 サイトのいずれかの部分にアクセスまたは使用すると、これらの利用規約に同意したものとみなされます。 本契約のすべての条件に同意しない場合は、サイトにアクセスしたり、サービスを利用したりすることはできません。 これらの利用規約がオファーであるとみなされる場合、承諾は明示的にこれらの利用規約に制限されます。</p>
    <p>ストアに新しい機能やツールを追加する場合も利用規約の制限対象となります。 このページでいつでも利用規約の最新版を確認できます。 当社は、当社の ウェブ サイトに更新および/または変更を掲載することにより、本利用規約の一部を更新、変更、または置き換える権利を留保します。 このページに変更がないか定期的に確認するのは貴殿の責任であります。 変更が投稿された後もサイトの使用またはアクセスを継続する場合、それらの変更を承諾したとみなされます。</p>
    <p>当社のストアは Shopify Inc. で運営されています。Shopify Inc. は、当社の製品やサービスをお客様に販売できるオンライン e コマース プラットフォームを提供します。</p>
    <ol>
      <li>
        <h5>1.オンラインストア規約</h5>
        <p>これらの利用規約に同意することにより、お客様は、お住まいの市または地方で成人年齢以上であること、またはお住まいの市または地方で成人年齢に達しており、当社に以下の情報を提供したことを表明するものとします。保護者がこのサイトの使用を許可することに同意します。</p>
        <p>当社の製品を違法または無許可の目的で使用したり、管轄区域内の法律 (著作権法を含むがこられに限定されない) に違反してサービスを使用したりすることはできません。 ワーム、ウイルス、または破壊的な性質のコードを送信してはなりません。</p>
        <p>これらの規約のいずれかに違反した場合、サービスは即時に終了されます。</p>
      </li>
      <li>
        <h5>2.一般条件</h5>
        <p>当社は、いつでも、理由の如何を問わず、誰に対してもサービスを拒否する権利を留保します。</p>
        <p>お客様は、お客様のコンテンツ (クレジット カード情報を除く) が暗号化されずに送信される可能性があり、(a) さまざまなネットワークを介した送信、(b) 接続するネットワークまたはデバイスの技術要件に準拠および適応するための変更が含まれることを理解するものとします。 クレジット カード情報は、ネットワーク上での送信中に常に暗号化されます。</p>
        <p>お客様は、当社の書面による明示的な許可なしに、本サービスの一部、本サービスの使用、本サービスへのアクセス、または本サービスが提供される ウェブ サイト上の連絡先詳細のいかなる部分もコピー、販売、再販、または悪用しないことに同意するものとします。</p>
        <p>本契約で使用される見出しは便宜上のものであり、これらの条件を制限したり、その他の影響を与えることはありません。</p>
      </li>
      <li>
        <h5>3.情報の正確性、完全性、適時性</h5>
        <p>このウェブサイトで提供される情報が不正確、不完全、または最新でない場合、当社は責任を負いません。 このウェブサイトの資料は一般的な情報のみを目的として提供されており、一次的、より正確、より完全、またはよりタイムリーな情報源を参照することなく、信頼したり、意思決定の唯一の根拠として使用したりしないでください。 この ウェブ サイトの資料に依存する場合は、ご自身でリスクを負うことになります。</p>
        <p>このウェブサイトには特定の過去の情報が含まれている場合があります。 過去の情報は必ずしも最新であるとは限らず、情報提供のみを目的として提供されています。 当社は、いつでもこのウェブサイトのコンテンツを変更する権利を留保しますが、当社はウェブサイト上の情報を更新する義務はありません。 あなたは、当社のウェブサイトの変更を監視する責任があると同意するとします。</p>
      </li>
      <li>
        <h5>4.サービスおよび価格の変更</h5>
        <p>弊社製品の価格は予告なく変更される場合がございます。</p>
        <p>当社は、いつでも予告なくサービス (またはその一部またはコンテンツ) を変更または中止する権利を留保します。</p>
        <p>当社は、サービスの変更、価格変更、一時停止または中止について、お客様または第三者に対して責任を負いません。</p>
      </li>
      <li>
        <h5>5.製品またはサービス (該当する場合)</h5>
        <p>特定の製品またはサービスは、ウェブ サイトを通じてオンラインでのみ利用できる場合があります。 これらの製品またはサービスは数量が限られている場合があり、当社の返品ポリシーに従って返品または交換しかできません。</p>
        <p>店内に掲載されている商品の色や画像をできる限り正確に表現するようできるだけ尽力します。 コンピューターのモニターに表示される色が正確であることは保証できません。</p>
        <p>当社は、当社の製品またはサービスの販売をいかなる人物、地理的地域または管轄区域に制限する権利を留保しますが、そうする義務はありません。 当社はケースバイケースでこの権利を行使することがあります。 当社は、当社が提供する製品またはサービスの数量を制限する権利を留保します。 すべての製品説明または製品価格は、当社の独自の裁量により、予告なく変更される場合があります。 当社は、いかなる製品もいつでも中止する権利を留保します。 このサイトで提供される製品またはサービスのオファーは、禁止されている場合は無効になります。</p>
        <p>当社は、お客様が購入または入手した製品、サービス、情報、またはその他の素材の品質がお客様の期待を満たすこと、またはサービス内の誤りが修正されることを保証しません。</p>
      </li>
      <li>
        <h5>6.請求およびアカウント情報の正確性</h5>
        <p>当社は、お客様からのいかなる注文を拒否する権利を留保します。 当社は、独自の裁量により、1人当たり、1つアカウント当たり、または注文当たりの購入数量を制限またはキャンセルする場合があります。 これらの制限には、同じ顧客アカウント、同じクレジット カードによる注文、または同じ顧客アカウント、同じクレジット カードによる注文、および/または同じ請求先住所および/または配送先住所を使用した注文が含まれる場合があります。 注文を変更またはキャンセルする場合、注文時に指定したメールアドレスおよび/または請求先住所/電話番号に連絡することで通知を試みる場合があります。 当社は、当社の判断により、ディーラー、再販業者、または販売代理店によって行われたと思われる注文を制限または禁止する権利を留保します。</p>
        <p>お客様は、当店で行われたすべての購入について、最新かつ完全かつ正確な購入情報およびアカウント情報を提供することに同意するものとします。 お客様は、当社との取引を完了し、必要に応じてお客様に連絡できるよう、お客様のアカウントおよびメール アドレス、クレジット カード番号、有効期限を含むその他の情報を速やかに更新することに同意するものとします。</p>
        <p>詳細については、返品ポリシーをご覧ください。</p>
      </li>
      <li>
        <h5>7.オプションツール</h5>
        <p>当社は、サードパーティ ツールへのアクセスをお客様に提供する場合があります。当社はそれを監視したり、制御や入力することはしません。</p>
        <p>お客様は、当社がいかなる種類の保証、表明、または条件もなく、いかなる承認もなしに、サードパーティツールへのアクセスを「現状のまま」および「利用可能な限り」提供することを認め、これに同意するものとします。 当社は、お客様によるオプションのサードパーティ ツールの使用に起因または関連するいかなる責任については責任を負いません。</p>
        <p>サイトを通じて提供されるオプション ツールの使用は完全にお客様自身のリスクとなり、関連するサードパーティ プロバイダーによってツールが提供される条件をよく理解し、承認する必要があります。</p>
        <p>将来的には、サイトを通じて新しいサービスや機能を提供する可能性もあります (新しいツールやリソースのリリースを含む)。 このような新しい機能および/またはサービスも、本利用規約の対象となります。</p>
      </li>
      <li>
        <h5>8.サードパーティのリンク</h5>
        <p>当社のサービスを通じて提供される特定のコンテンツ、製品、およびサービスには、第三者からの素材が含まれる場合があります。</p>
        <p>この ウェブ サイト上のサードパーティのリンクは、当社と提携していないサードパーティの ウェブ サイトにアクセスする場合があります。 当社は、内容や正確性を調査または評価する責任を負わず、第三者の資料や ウェブ サイト、あるいは第三者のその他の資料、製品、サービスについては保証せず、いかなる責任も負わないものとします。</p>
        <p>当社は、サードパーティのサイト商品、サービス、リソース、コンテンツの購入または使用、サードパーティのサイトに関連するその他の取引に関連する怪我や損害については責任を負いません。 取引を開始する前に、第三者のポリシーと慣行をぜひ理解してください。 サードパーティ製品に関する苦情、クレーム、懸念、または質問は、サードパーティに送信してください。</p>
      </li>
      <li>
        <h5>9.ユーザーからのコメント、フィードバック、その他の意見</h5>
        <p>当社の要請に応じて特定の提出物 (エントリー作品など) を送信する場合、または当社の要請がない場合に、オンライン、電子メール、郵送などでアイデア、提案、提案、計画、またはその他の資料 (総称して「コメント」) を送信する場合, あなたは、あなたが私たちに転送したコメントを、いつでも制限なく編集、複製、出版、配布、翻訳、その他あらゆるメディアで使用できることに同意します。 当社には、(1) コメントの機密性を保持すること、(2) コメントの補償、(3) コメントに返信する義務はありません。</p>
        <p>当社は、独自の裁量により、違法、攻撃的、脅迫的、中傷的、ポルノ的、わいせつ、その他気味が悪いコンテンツ、または当事者の知的財産権または本規約に違反すると判断したコンテンツを監視、編集、削除することができますが、そうする義務はありません。</p>
        <p>あなたは、あなたのコメントが著作権、商標、プライバシー、人格権、その他の個人的権利または所有権を含む第三者の権利を侵害しないことに同意します。 さらに、お客様は、お客様のコメントには、中傷的またはその他の違法、虐待的またはわいせつな内容が含まれていないこと、本サービスまたは関連 ウェブ サイトの運営に何らかの形で影響を与える可能性のあるコンピューター ウイルスやその他の悪意のあるソフトウェアが含まれていないことに同意するものとします。 偽の電子メール アドレスを使用したり、本人ではないふりをしたり、コメントの出所に関して当社や第三者に誤解を与えたりすることはできません。 あなたは、自分が行ったコメントとその正確さについて単独で責任を負います。 当社は、お客様または第三者が投稿したコメントについては責任を負いません。</p>
      </li>
      <li>
        <h5>10.個人情報</h5>
        <p>ストアを通じてアップロードされた個人情報には、当社のプライバシー ポリシーに適用します。 プライバシーポリシーを見る</p>
      </li>
      <li>
        <h5>11.誤り、不正確および脱落</h5>
        <p>当社のサイトまたはサービス上の情報には、製品の説明、価格設定、プロモーション、特典、製品の配送料、配送時間および在庫状況に関する誤字、不正確または欠落が含まれる場合があります。 当社は、サービスまたは関連ウェブサイト上の情報が不正確な場合には、いつでもエラー、不正確、または脱落を修正し、情報を変更または更新するか、予告なしに (注文の送信後を含む) 注文をキャンセルする権利を留保します。</p>
        <p>当社は、法律で義務付けられている場合を除き、価格情報を含むがこれに限定されない、サービスまたは関連ウェブサイト上の情報を更新、修正、またはそれを明確にする義務を負いません。 本サービスまたは関連ウェブサイトに指定された更新日または更新日を使用しない場合は、本サービスまたは関連ウェブサイト上のすべての情報が改訂または更新されたことを示すものとみなされます。</p>
      </li>
      <li>
        <h5>12.使用禁止</h5>
        <p>利用規約に定められているその他の禁止事項に加えて、このサイトまたはそのコンテンツを次の目的で使用することはできません: (a) 違法な目的で使用すること、(b) 他人に違法行為を行うまたは違法行為に参加するよう勧誘すること、(c) 国際、国、地方または市の法令、規則、法律、または地方条例を違反すること、(d) 当社または他者の知的財産権の侵害すること、(e) 性別、性的指向、宗教、人種、民族、年齢、出身国、または障害者を虐待したり、侮辱したり、害したり、中傷したり、誹謗したり、威嚇したり、または差別に扱ったりこと、(f) 虚偽または誤解を招く情報の送信、(g) ウイルスまたはその他の種類の悪意のあるコードのアップロードまたは送信本サービス、関連する ウェブ サイト、他の ウェブ サイト、またはインターネットの機能や運用を使用、または何らかの方法で使用、影響を与える可能性のあるもの、(h) 他者の個人情報の収集または追跡、(i) スパム、フィッシング、フィッシング、なりすまし、スパイダーリング、クロールまたはスクレーピング、(j) わいせつまたはほか不道徳な目的、(k) 本サービスまたは関連する ウェブ サイト、他の ウェブ サイト、またはインターネットのセキュリティ機能を妨害または規約を回避すること。 当社は、本サービスまたは関連ウェブサイトの禁止されている使用に対するお客様の違反を終了する権利を留保します。
        </p>
      </li>
      <li>
        <h5>13.保証の否認、責任の制限</h5>
        <p>当社は、お客様による当社のサービスの使用が中断されず、タイムリーに、安全に、またはエラーが発生しないことを保証したり、表明したりことはしません。</p>
        <p>当社は、本サービスの使用から得られる結果が正確であるか、信頼できるかについては保証しません。</p>
        <p>お客様は、当社がいつでも予告なしにサービスを無期限に削除したり、サービスをキャンセルしたりする場合があることに同意するものとします。</p>
        <p>お客様は、サービスの使用、または使用不能がもたらすリスクをご了承ください。 本サービス、および本サービスを通じてお客様に提供されるすべての製品およびサービス (当社が正式な声明を発表した場合以外) は、お客様の使用のために「現状のまま」および「利用可能なまま」提供され、明示的か黙示的かを問わず、いかなる種類の表明、保証または条件も含まれません。すべて 商品性、商品品質、特定目的への適合性、耐久性、所有権および非侵害に関する黙示の保証または条件。</p>
        <p>いかなる場合においても、当社の取締役、役員、一般社員、関連会社、代理店、請負業者、インターン、サプライヤー、サービスプロバイダー、またはライセンサーは、損害、損失、請求、または直接的、間接的、付随的、懲罰的、特別または結果的損害賠償責任に対して責任を負わないものとします。コンテンツの誤りや脱落、サービスまたは投稿、送信、またはその他の方法で作成されたコンテンツ (または製品) の使用から生じるあらゆる種類の損失や損害を含むがこれに限定されない、あらゆる種類の損失性別の可能性について通知されている場合でも。</p>
        <p>一部の市または管轄区域では、結果的損害または付随的損害に対する責任の除外または制限が認められていないため、そのような市または管轄区域では、当社の責任は法律で認められる最大限の範囲に限定されるものとします。</p>
      </li>
      <li>
        <h5>14.補償</h5>
        <p>お客様は、当社および当社の親会社、子会社、関連会社、パートナー、役員、取締役、代理店、請負業者、ライセンサー、サービスプロバイダー、下請け業者、サプライヤー、インターンおよび従業員に対して行動し、あらゆる請求または要求から補償し、弁護し、免責することに同意するものとします。これには、本利用規約または参照により組み込まれた文書に対するお客様の違反、または法律または第三者の権利の違反に起因する、第三者の合理的な弁護士費用が含まれます。</p>
      </li>
      <li>
        <h5>15.可分性</h5>
        <p>本利用規約のいずれかの条項が違法、無効、または法的強制力がないと判断された場合でも、その条項は適用法で認められる最大限の範囲で法的強制力を持つものとし、法的強制力のない部分は本利用規約から切り離されたものとみなされます。そして、そのような決定は、その他の残りの規定の有効性および法的強制力には影響を与えないものとします。</p>
      </li>
      <li>
        <h5>16.終了</h5>
        <p>いかなる目的においても、終了日より前に発生した両当事者の義務および責任は、本契約の終了後も存続するものとします。</p>
        <p>これらの利用規約は、お客様または当社によって終了されるまで有効です。お客様は、当社のサービスの使用を希望しないこと、または当社のウェブサイトの使用を停止することを当社に通知することにより、いつでも本利用規約を終了することができます。</p>
        <p>また、当社の独自の判断により、お客様が本利用規約の条項を遵守できない、または遵守しなかった場合には、当社は随時予告なく本契約を終了することができ、お客様は引き続き未払い金の全額について責任を負います。終了日まで、および/またはそれに応じて当社サービス (またはその一部) へのアクセスを拒否する場合があります。</p>
      </li>
      <li>
        <h5>17.完全な合意</h5>
        <p>当社が本利用規約の権利または条項を行使または実行しなかった場合、その権利または条項の放棄するとみなされません。</p>
        <p>これらの利用規約および当社がこのサイトに掲載する、またはサービスに関連して掲載するポリシーや運営規則は、お客様と当社との間の完全な合意および理解を構成し、お客様によるサービスの使用を管理し、以前または同時の契約、連絡および提案に優先します。口頭でも、は、お客様と当社との間で書面により締結されます（以前のバージョンの利用規約を含みますがこれに限定されません）。</p>
        <p>利用規約の解釈に曖昧さがある場合でも、本規約の起草者に不利な解釈を行ってはなりません。</p>
      </li>
      <li>
        <h5>18.利用規約の変更</h5>
        <p>いつでもこのページで利用規約の最新版を確認できます。</p>
        <p>当社は、独自の裁量により、更新および変更を当社の ウェブ サイトに掲載することにより、本利用規約の一部を更新、変更、または置き換える権利を留保します。 当社ウェブサイトに変更がないか定期的に確認するのはお客様の責任です。 これらの利用規約への変更が掲載された後も、当社のサイトまたはサービスへの継続的な使用またはアクセスは、それらの変更を承諾したものとみなされます</p>
      </li>
      <li>
        <h5>19.準拠法</h5>
        <p>これらの利用規約および当社がお客様にサービスを提供する際の個別の契約は、現地法に準拠し、それに従って解釈されるものとします。</p>
      </li>
    </ol>
  </div>`,
	},
	// 商品列表
	// productList: [
	//   {
	//     id: 1,
	//     imgUrl: "pro1-1.jpg",
	//     title: "SASAVIN蛋白棒",
	//     singlePrice: 7780,
	//     bigProduct:['pro1-2.png','pro1-3.png']
	//   },
	//   {
	//     id: 2,
	//     imgUrl: "pro2-1.jpg",
	//     title: "朵匠、优姿轻解素、益生元多肽片压片糖果",
	//     singlePrice: 10610,
	//     bigProduct:['pro2-2.jpg','pro2-3.jpg']

	//   },
	//   {
	//     id: 3,
	//     imgUrl: "pro3-1.jpg",
	//     title: "亨德仁源堂油切分解素双菇多肽粉固体饮料",
	//     singlePrice: 6790,
	//     bigProduct:['pro3-2.jpg','pro3-3.jpg']

	//   },
	//   {
	//     id: 4,
	//     imgUrl: "pro4-1.jpg",
	//     title: "极魅曲然堂、低脂高纤型代餐营养粉",
	//     singlePrice: 9760,
	//     bigProduct:['pro4-2.jpg','pro4-3.jpg']

	//   },
	//   {
	//     id: 5,
	//     imgUrl: "pro5-1.jpg",
	//     title: "蓝莓复合益生元固体饮料",
	//     singlePrice: 10892,
	//     bigProduct:['pro5-2.jpg','pro5-3.jpg']

	//   },
	//   {
	//     id: 6,
	//     imgUrl: "pro6-1.jpg",
	//     title: "诺丽果低聚果糖压片",
	//     singlePrice: 10610,
	//     bigProduct:['pro6-2.png','pro6-3.png']

	//   },
	//   {
	//     id: 7,
	//     imgUrl: "pro7-1.jpg",
	//     title: "奇亚籽固体饮料",
	//     singlePrice: 10610,
	//     bigProduct:['pro7-2.jpg','pro7-3.jpg']

	//   },
	//   {
	//     id: 8,
	//     imgUrl: "pro8-1.jpg",
	//     title: "轻姿溶解素",
	//     singlePrice: 21360,
	//     bigProduct:['pro8-2.jpg','pro8-3.jpg']

	//   },
	//   {
	//     id: 9,
	//     imgUrl: "pro9-1.jpg",
	//     title: "神奇粉末，固体饮料",
	//     singlePrice: 6508,
	//     bigProduct:['pro9-2.jpg','pro9-3.png']

	//   },
	//   {
	//     id: 10,
	//     imgUrl: "pro10-1.jpg",
	//     title: "神奇粉末益生菌果蔬植物酵素粉",
	//     singlePrice: 10610,
	//     bigProduct:['pro10-2.jpg','pro10-3.png']
	//   },
	//   {
	//     id: 11,
	//     imgUrl: "pro11-1.jpg",
	//     title: "新活力因子",
	//     singlePrice: 7356,
	//     bigProduct:['pro11-2.png','pro11-3.jpg','pro11-4.jpg']

	//   },
	//   {
	//     id: 12,
	//     imgUrl: "pro12-1.jpg",
	//     title: "新--芊润易简玫奇亚籽固体饮料",
	//     singlePrice: 10610,
	//     bigProduct:['pro12-2.png','pro12-3.png']

	//   },
	//   {
	//     id: 13,
	//     imgUrl: "pro13-1.jpg",
	//     title: "伊美源、轻轻果冻果味型果冻",
	//     singlePrice: 10610,
	//     bigProduct:['pro13-2.jpg','pro13-3.jpg']

	//   },
	//   {
	//     id: 14,
	//     imgUrl: "pro14-1.jpg",
	//     title: "植物三调茶",
	//     singlePrice: 10610,
	//     bigProduct:['pro14-2.jpg','pro14-3.png','pro14-4.png']

	//   },
	//   {
	//     id: 15,
	//     imgUrl: "pro15-1_ja.png",
	//     title: "差額 を補い ます",
	//     singlePrice: 1,
	//   },
	// ],
	productList: [],

	cartList: [],
	retail: {
		id: 15,
		imgUrl: 'pro15-1_ja.png',
		title: '差額 を補い ます',
		singlePrice: 1,
		isRetail: true,
	},
}
